export var HEADER = 'HEADER';
export var BODY = 'BODY';
export var FOOTER = 'FOOTER';
export var OVERLAY = 'OVERLAY';
export var FIXED = 'FIXED';
